var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.0517 5.42388L11.3797 4.74366L9.28782 0.51053C8.98062 -0.114838 7.95479 -0.114838 7.64942 0.51053L5.55938 4.74366L0.889226 5.42388C0.545456 5.47325 0.258373 5.71462 0.150487 6.04559C0.0426022 6.37656 0.132201 6.73862 0.380885 6.98182L3.76007 10.2751L2.96647 14.9306C2.90796 15.2744 3.04876 15.62 3.33036 15.8229C3.61378 16.0277 3.98681 16.057 4.29401 15.8924L8.47045 13.6963L12.6469 15.8924C12.7804 15.9637 12.9248 15.9985 13.0711 15.9985C13.2613 15.9985 13.4496 15.94 13.6087 15.8229C13.8885 15.62 14.0311 15.2725 13.9726 14.9306L13.1753 10.2769L16.5564 6.98365C16.8069 6.74045 16.8965 6.37656 16.7886 6.04559C16.6807 5.71462 16.3954 5.47508 16.0517 5.42388Z","fill":"#EF4335"}));
}

Star.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = Star;

Star.default = Star;
